export const locale = {
  mainSeries: 'Change main series',
  compareHint: 'Compare',
  fullScreen: 'Fullscreen mode',
  relativeMode: 'Toggle Percentage',
  compare: 'Compare',
  rt: 'Auto update',
  timeRange: 'Change time range',
  eodTimeRange: 'Change time range',
  hvTerm: 'Change HV',
  ivxTerm: 'Change Period',
  optionType: 'Change Option type',
  moneyness: 'Change Moneyness',
  dateTime: 'Change date on main series',
  date: 'Change date',
  time: 'Change time',
  totalOiChartType: 'Change type',
  close: 'Delete chart card',
  screenshot: 'Save a screenshot of the chart',
  changeIvDiffStock: 'Change Stock',
  firstPoint: 'Point 1',
  secondPoint: 'Point 2',
  'ivxTerm-first': 'Change Period',
  'ivxTerm-second': 'Change Period',
  'stockId-first': 'Change stock',
  'stockId-second': 'Change stock',
  'moneyness-first': 'Change Moneyness',
  'moneyness-second': 'Change Moneyness',
  vWap: 'Show VWAP',
  vWapHint: 'VWAP (Volume-Weighted Average Price) is calculated by adding up the dollars traded for every transaction (price multiplied by number of shares traded) and then dividing by the total shares traded for the day.',
  vWapHintNoData: 'There is no VWAP for this instrument',
  expirationDate: 'Change expiration date',
  strike: 'Change strike',
  intraDayChartType: 'Change chart type',
  singleContractAnalyzerType: 'Change chart type'
};
